import { API } from "@/services"

export const SERVER_ENDPOINTS = {
  create(data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server`,
      method: 'POST',
      data,
    })
  },
  get(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `server`,
      method: 'GET',
      params,
    })
  },
  chart(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/chart`,
      method: 'GET',
      params,
    })
  },
  statusChart(params={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/chart/status`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/${id}`,
      method: 'PUT',
      data,
    })
  },
  checkStatus(id='',data={}){
    return API.Axios.universal_ai.v1.request({
      url: `server/${id}/check-status`,
      method: 'PATCH',
      data,
    })
  },
}